import { render, staticRenderFns } from "./AuthPageContainer.vue?vue&type=template&id=9480261c&lang=pug&"
import script from "./AuthPageContainer.vue?vue&type=script&lang=js&"
export * from "./AuthPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports